import { useNavigate } from "react-router-dom"

import {
    Stack,
    Typography,
    Box,
    Card,
    CardContent,
    CardActions,
    CardMedia
} from '@mui/material'
import CardHeader from '@mui/material/CardHeader'

import { ColorButton } from './button.js'

const CustomCard = (props) => {
    const navigator = useNavigate()

    return (
        <Card
            sx={{
                width: { xs: 1, md: 1 / 3.5 },
                my: 3,
                borderRadius: "1rem",
                boxShadow: { xs: '0px 0px 3px 0px #6286A1', md: '0px 0px 7px 0px #6286A1' },
                '&:hover': {
                    boxShadow: { xs: '0px 0px 3px 0px #368F80', md: '0px 0px 7px 0px #368F80' },
                },
            }}
        >
            <CardHeader title={props.title} />
            <Box
                position="relative"
                zIndex={1}
            >
                <CardMedia
                    component="img"
                    width="100%"
                    height={350}
                    image={props.media}
                    alt={props.title}
                />
                <Box
                    position="absolute"
                    zIndex={2}
                    width={'100%'}
                    height={'100%'}
                    top={0}
                    left={0} />
            </Box>
            <CardContent>
                <Stack
                    direction={{ xs: 'column' }}
                    justifyContent={{ xs: 'center' }}
                    alignItems='center'
                    spacing={{ xs: 3 }}
                    px={{ md: 1 }}
                    mb={{ xs: 3}}
                >
                    <Typography
                        variant="span"
                        fontWeight={900}
                        fontSize={{ xs: '1.5rem', md: '2.1rem' }}
                        fontFamily={"Montserrat, sans-serif"}
                        gutterBottom
                    >
                        {props.budget}
                        <Typography
                            variant="span"
                            fontWeight={700}
                            fontSize={{ xs: '0.5rem', md: '0.8rem' }}
                            fontFamily={"Montserrat, sans-serif"}
                            textAlign="start"
                        >
                            EG
                        </Typography>
                    </Typography>
                </Stack>
                <Stack
                    direction={{ xs: 'column' }}
                    justifyContent={{ xs: 'flex-start' }}
                    alignItems='flex-start'
                    spacing={{ xs: 3 }}
                    px={{ md: 1 }}
                >
                    {props.description.map((item) =>
                        <Typography
                            key={item}
                            variant="p"
                            fontWeight={700}
                            fontSize={{ xs: '0.71rem', md: '1rem' }}
                            fontFamily={"Montserrat, sans-serif"}
                        >
                            {item}
                        </Typography>
                    )}
                </Stack>
            </CardContent>
            <CardActions
                sx={{
                    justifyContent: 'center',
                    my: { xs: 3 }
                }} >
                <ColorButton
                    size="medium"
                    onClick={() => navigator("/reservation")}>
                    BOOK NOW</ColorButton>
            </CardActions>
        </Card >
    )
}

export default CustomCard